import React, { useEffect, useState, useMemo, useRef } from 'react'
import {
  Edit,
  SimpleForm,
  useTranslate,
  BooleanInput,
  FormDataConsumer,
  useNotify,
  useRedirect,
  required,
  useEditController,
  minValue,
  maxValue,
  useUpdate,
} from 'react-admin'
import { Grid, Box, Paper, Skeleton } from '@mui/material'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import dayjs from 'dayjs'
import { CardCommon } from 'src/components/uiElements'
import { AdapterToMapperJson } from './logic/AdapterToMapperJson'
import { FormulaComponent } from './logic/FormulaComponent'
import { productServices } from 'src/services/reservation/product/product.service'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { TextInput } from 'src/components/uiElements/fields/TextInput'
import { TreeViewCheck } from 'src/components/uiElements/styledComponents/TreeViewCheck'
import { Modal, Button, Typography } from '@mui/material'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import { GetTrainSegmentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/TrainSegmentFields'
import { GetAirFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/AirFields'
import { GetInstallmentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/InstallmentFields'
import { GetHotelFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/HotelFields'
import { GetCarFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/CarFields'
import { GetPaymentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/PaymentFields'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { mapperHelperService } from 'src/services/auth/mapperHelper.service'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'
import {
  formatCheckedBox,
  updateCheckBox,
  waitVariablesFormat,
} from 'src/components/pages/sales/business-rule/helper/vars_helper'
import { operators } from 'src/components/pages/sales/business-rule/logic/ListOperators'
import { CardParentFormula } from 'src/components/pages/sales/business-rule/logic/CardParentFormula'
import { CardTestFormula } from 'src/components/pages/sales/business-rule/logic/CardTestFormula'
import { validateNameIsValid } from 'src/components/pages/sales/business-rule/helper/validations'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'
import { SettingRuleComponent } from 'src/components/pages/sales/business-rule/logic/settingRule/SettingRuleComponent'
import { productTypeServices } from 'src/services/reservation/product-type/product_type.service'
import {
  AIR,
  HOTEL,
  PAYMENT_METHOD,
  INSTALLMENT_METHOD,
  BILLING,
  CAR,
  PAYMENT_CHARGE,
  LIQUIDATION,
  OTHER,
  TRAIN_SEGMENT,
  TRAIN_PASSES,
  SETTING,
  CONTENT,
  PRODUCT_TYPE_OTHER_ID,
  OTHER_DETAIL,
  PRICE,
} from 'src/components/pages/sales/business-rule/helper/const'
import { transform } from 'src/components/pages/sales/business-rule/helper/transform'
import { GetPaymentChargeComponentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/PaymentFieldsComponent'
import { getRefTableDetail } from 'src/components/pages/sales/business-rule/helper/getRefTableDetail'
import { transformData } from 'src/components/pages/sales/business-rule/helper/formula_helper'
import { GetOtherProductFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/OtherProductFields'
import { getAllChildrensId } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getAllChildrensId'
import { useFormContext } from 'react-hook-form'
import { ContentRuleComponent } from 'src/components/pages/sales/business-rule/logic/contentRule/ContentRuleComponent'
import { supplierServices } from 'src/services/reservation/supplier/supplier.service'
import { getCurrentWorkUnit } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getCurrentWorkUnit'
import { filterProducts } from 'src/components/pages/sales/business-rule//helper/filterProduct'
import { getBaseToBilling } from 'src/components/pages/sales/business-rule/helper/getBaseToBiling'
import { GlobalVariables } from 'src/components/pages/sales/business-rule/logic/GlobalVariables'
import { TranslateRuleType } from 'src/components/pages/sales/business-rule/helper/TranslateRuleType'
import { SelectInputSearch } from 'src/components/uiElements/fields/SelectInputSearch'

const RemoveProductIfProductChange = ({ currentWorkUnitToken }) => {
  const { setValue } = useFormContext()

  useEffect(() => {
    if (currentWorkUnitToken) {
      setValue('product_id', '')
      setValue('business_unit_token', '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnitToken])
}

export const BusinessRuleEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const { record, isLoading, isFetching } = useEditController()
  const [update] = useUpdate('business-rule')
  const [loadedInitialData, setLoadedInitialData] = useState(false)
  const [loadedInitialProduct, setLoadedInitialProduct] = useState(true)
  const [ruleTypes, setRuleTypes] = useState([])
  const [loadingRuleTypes, setLoadingRuleTypes] = useState(false)
  const [businessRules, setBusinessRules] = useState([])
  const [loadingBusinessRules, setLoadingBusinessRules] = useState(false)
  const [allWorkUnits, setAllWorkUnits] = useState([])
  const [loadingWorkUnits, setLoadingWorkUnits] = useState(false)
  const [loadingBusinessUnits, setLoadingBusinessUnits] = useState(false)
  const [businessUnits, setBusinessUnits] = useState([])
  const [products, setProducts] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(false)
  const [destinationTypes, setDestinationTypes] = useState([])
  const [loadingDestinationTypes, setLoadingDestinationTypes] = useState(false)
  const [loadingAirSources, setLoadingAirSources] = useState(false)
  const [airSuppliers, setAirSuppliers] = useState([])
  const [loadingAirSuppliers, setLoadingAirSuppliers] = useState(false)
  const [airAirlines, setAirAirlines] = useState([])
  const [loadingAirAirlines, setLoadingAirAirlines] = useState(false)
  const [hotelCountries, setHotelCountries] = useState([])
  const [loadingHotelCountries, setLoadingHotelCountries] = useState(false)
  const [hotelCities, setHotelCities] = useState([])
  const [loadingHotelCities, setLoadingHotelCities] = useState(false)
  const [paymentTypes, setPaymentTypes] = useState([])
  const [loadingPaymentTypes, setLoadingPaymentTypes] = useState(false)
  const [paymentMethodsBank, setPaymentMethodsBank] = useState([])
  const [selectedRuleType, setSelectedRuleType] = useState()
  const [selectedProduct, setSelectedProduct] = useState()
  const [selectedCountries, setSelectedCountries] = useState([])
  const [selectedPaymentMethodsBank, setSelectedPaymentMethodsBank] = useState([])
  const [selectedPaymentMethodsCard, setSelectedPaymentMethodsCard] = useState([])
  const [showJsonInput, setShowJsonInput] = useState(false)
  const [json, setJson] = useState(null)
  const [canChangeJson, setCanChangeJson] = useState(false)
  const [jsonParse, setJsonParse] = useState({})
  const [formulas, setFormulas] = useState([])
  const [formulaData, setFormulaData] = useState()
  const [currentWorkUnit, setCurrentWorkUnit] = useState({})
  const [currentWorkUnitToken, setCurrentWorkUnitToken] = useState([])
  const [currentWorkUnitName, setCurrentWorkUnitName] = useState('')
  const [expanded, setExpanded] = useState([])
  const [currentParentRuleId, setCurrentParentRuleId] = useState(0)
  const [parentStructureFormula, setParentStructureFormula] = useState()
  const [parentInfo, setParentInfo] = useState()
  const [loadingParentFormula, setLoadingParentFormula] = useState(false)
  const [productTypes, setProductTypes] = useState(null)
  const [productType, setProductType] = useState(null)
  const [loadingProductType, setLoadingProductType] = useState(false)
  const [hashProducts, setHashProducts] = useState([])
  const [baseToBilling, setBaseToBilling] = useState([])
  const [loadingBaseBilling, setLoadingBaseBilling] = useState(false)
  const [businessUnitIds, setBusinessUnitIds] = useState([])
  const [businessUnit, setBusinessUnit] = useState([])
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState()
  const [selectedBillingBases, setSelectedBillingBases] = useState()

  const [formulaStructure, setFormulaStructure] = useState()
  const [startTakePicture, setStartTakePicture] = useState(false)

  const [checkedBox, setCheckedBox] = useState([])
  const [variablesFormat, setVariablesFormat] = useState([])
  const [formulasLoading, setFormulasLoading] = useState(false)
  const [jsonMapper, setJsonMapper] = useState({})
  const [loadingJsonMapper, setLoadingJsonMapper] = useState(false)
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = async () => {
    const work_unit = await getCurrentWorkUnit(allWorkUnits, currentWorkUnitToken)
    onChangeWorkUnit(work_unit)
    setOpen(false)
  }

  const [openTestFormula, setOpenTestFormula] = useState(false)
  const handleOpenTestFormula = () => setOpenTestFormula(true)
  const handleCloseTestFormula = () => {
    setOpenTestFormula(false)
  }

  const [loading, setLoading] = useState(true)
  const [optionBusinessUnit, setOptionBusinessUnit] = useState([])
  const [loadingBusinessUnit, setLoadingBusinessUnit] = useState(false)
  const [workUnitIdS, setWorkUnitIdS] = useState(false)
  const exportRef = useRef()

  const [isAddVar, setIsAddVar] = useState(false)
  const [businessUnitsOptionsSelected, setBusinessUnitsOptionsSelected] = useState([])

  useEffect(()=>{
    setSelectedBusinessUnit(record?.business_unit_token)
  },[record?.business_unit_token])

  useEffect(()=>{
    if(record?.base_to_billing){
      setSelectedBillingBases(record?.base_to_billing)
    } else {
      setSelectedBillingBases(['all'])
    }
  },[record?.base_to_billing])

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minHeight: '250px',
    minWidth: '550px',
    height: 'auto',
    width: 'auto',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    p: 4,
  }

  useEffect(() => {
    getProductType()
  }, [])

  useEffect(() => {
    if (currentWorkUnit.length && (selectedRuleType === PAYMENT_CHARGE || productType)) {
      getProducts(
        currentWorkUnit.map((wu) => wu?.id),
        null,
        null,
        false
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnit, productType, selectedRuleType])

  useEffect(() => {
    ;(async () => {
      try {
        setLoadingBaseBilling(true)
        if (currentWorkUnit.length) {
          const base_to_billing = await getBaseToBilling(currentWorkUnit, businessUnit, businessUnitIds)
          setBaseToBilling(base_to_billing)
          return
        }
        setBaseToBilling([{ name: 'Todas', value: 'all' }])
      } catch (error) {
        setBaseToBilling([{ name: 'Todas', value: 'all' }])
      } finally {
        setLoadingBaseBilling(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnit, businessUnitIds, businessUnit])

  useEffect(() => {
    ;(async () => {
      if (record) {
        getWorkUnits()
        getRuleTypes()
        getBusinessRecord()
        setBusinessUnit(record?.business_unit_token)
        const selectedBusinessUnitIds = businessUnits
          .filter((unit) => record?.business_unit_token?.includes(unit.token))
          .map((unit) => unit.id)
        setBusinessUnitIds(selectedBusinessUnitIds)
        getBusinessRules(null, record?.parent_rule ? `id=${record.parent_rule}` : null)
        getDestinationTypes()
        // getVersions(record.id)
        setCurrentParentRuleId(record.parent_rule ? record.parent_rule : null)
        setCurrentWorkUnitToken(record.work_unit_token)
        resolveFormula(record)
        if (HOTEL in record) {
          getHotelData(record.hotel?.country)
        }

        setSelectedRuleType(record.rule_type_id)
        setLoadedInitialData(true)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  useEffect(() => {
    setProductTypeByWorkUnitToken(record?.hash_product)
  }, [record, productTypes])

 
  useEffect(() => {
    ;(async () => {
      if (json && canChangeJson) {
        try {
          setLoadingJsonMapper(true)
          if (json.length !== 0) {
            const jsonParseHelper = await mapperHelperService(JSON.parse(json))
            setJsonParse(JSON.parse(json))
            setJsonMapper(jsonParseHelper)
          } else {
            setJsonMapper({})
            setJsonParse({})
          }
          setLoadingJsonMapper(false)
        } catch (error) {
          notify('ra.field.invalid_json', { type: 'error' })
          setLoadingJsonMapper(false)
          return
        }
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [json])

  useEffect(() => {
    ;(async () => {
      if (jsonParse && canChangeJson) {
        try {
          setFormulasLoading(true)
          if(isAddVar){
            updateCheckBox(jsonMapper, formulaData, checkedBox, setCheckedBox)
            await waitVariablesFormat(checkedBox, variablesFormat)
            setIsAddVar(false)
          } else {
            // checkJson()
            let removeOldData = { var: formulaData?.var, data: {} }
            if (
              record?.request &&
              record?.formula?.data?.data &&
              JSON.stringify(jsonParse) === JSON.stringify(record.request)
            ) {
              removeOldData.data = record.formula.data.data
            }
            updateCheckBox(jsonParse, removeOldData, checkedBox, setCheckedBox)
            await waitVariablesFormat(checkedBox, variablesFormat)
          }
          setFormulasLoading(false)
        } catch (error) {
          setFormulasLoading(false)
        }
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonParse])

  useEffect(() => {
    ;(async () => {
      if (record && loadedInitialData && allWorkUnits.length > 0) {
        const work_unit = await getCurrentWorkUnit(allWorkUnits, record.work_unit_token)
        setCurrentWorkUnitName(showCurrentsWorkunit(work_unit))
        onChangeWorkUnit(work_unit, record.business_unit_token, true)
        if (record.rule_type_id === PAYMENT_METHOD) {
          getPaymentType(record.work_unit_token, record.payment?.card?.[0])
        }
        setLoadedInitialData(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, loadedInitialData, allWorkUnits])

  useEffect(() => {
    ;(async () => {
      const isSameWorkUnitToken = (currentWorkUnitTokens, currentWorkUnits) => {
        if (currentWorkUnitTokens.length !== currentWorkUnits.length) {
          return false
        }

        return currentWorkUnitTokens.every((token) =>
          currentWorkUnits.some((workUnit) => workUnit?.token === token)
        )
      }
      if (
        !isSameWorkUnitToken(currentWorkUnitToken, currentWorkUnit) &&
        currentWorkUnitToken &&
        allWorkUnits.length !== 0
      ) {
        const work_unit = await getCurrentWorkUnit(allWorkUnits, currentWorkUnitToken)
        setCurrentWorkUnitName(showCurrentsWorkunit(work_unit))
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnitToken])

  useEffect(() => {
    let format_checkedBox = formatCheckedBox(checkedBox, operators, variablesFormat, formulas)
    setVariablesFormat(format_checkedBox)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedBox])

  useEffect(() => {
    if (products && products.length > 0) {
      const matchingProducts = products.filter((product) => record.product_token?.includes(product?.token))
      setSelectedProduct(matchingProducts || null)
      if (loadedInitialProduct){
        const product = products?.[0]
        if (product) {
          getAirData(product?.product_type_id)
          setLoadedInitialProduct(false)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products])

  useEffect(() => {
    if (currentParentRuleId > 0 && selectedRuleType !== SETTING && selectedRuleType !== CONTENT) {
      getParentRule(currentParentRuleId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentParentRuleId])

  const menuRef = useRef(null);
 

  useEffect(() => {
    setLoading(
      loadingRuleTypes ||
        loadingBusinessRules ||
        loadingWorkUnits ||
        loadingBusinessUnits ||
        loadingProducts ||
        loadingDestinationTypes ||
        loadingAirSources ||
        loadingAirSuppliers ||
        loadingAirAirlines ||
        loadingHotelCountries ||
        loadingHotelCities ||
        loadingPaymentTypes ||
        isLoading ||
        isFetching
    )
  }, [
    loadingRuleTypes,
    loadingBusinessRules,
    loadingWorkUnits,
    loadingBusinessUnits,
    loadingProducts,
    loadingDestinationTypes,
    loadingAirSources,
    loadingAirSuppliers,
    loadingAirAirlines,
    loadingHotelCountries,
    loadingHotelCities,
    loadingPaymentTypes,
    isLoading,
    isFetching,
  ])


  const sortSelectedOptionsFirst = (options, selectedOptions) => {
    const selectedTokens = new Set(selectedOptions)
    let sortOptions = [
      ...options.filter((option) => selectedTokens.has(option.token)),
      ...options.filter((option) => !selectedTokens.has(option.token)),
    ]
    sortOptions.unshift({
      token: 'all',
      fantasy_name: 'Todas',
      fiscal_data_name: 'Todas',
      id: 9999999,
    })
    return sortOptions
  }

  const setProductTypeByWorkUnitToken = async (hash_product) => {
    try {
      if (Array.isArray(hash_product) && hash_product.length > 0) {
        const product = await productServices.getByAll({ hash_product: hash_product?.[0] })
        if (product) {
          if (product?.[0]?.ref_table_detail === OTHER_DETAIL) {
            // if it`s a 'other' product, set PRODUCT_TYPE_OTHER_ID
            setProductType(PRODUCT_TYPE_OTHER_ID)
            return
          }
          const productTypeFind = productTypes.find(
            (productType) => productType?.id == product?.[0]?.product_type_id
          )
          setProductType(productTypeFind?.id)
          return
        }
      }
      setProductType(null)
    } catch (error) {
      setProductType(null)
    }
  }

  const getJsonMapper = async (request) => {
    try {
      setLoadingJsonMapper(true)
      if (request) {
        const jsonParseHelper = await mapperHelperService(request)
        setJsonMapper(jsonParseHelper)
        setLoadingJsonMapper(false)
        return jsonParseHelper
      } else {
        setJsonMapper({})
      }
      setLoadingJsonMapper(false)
      return undefined
    } catch (error) {
      notify('ra.field.invalid_json', { type: 'error' })
      setLoadingJsonMapper(false)
    }
  }

  const resolveFormula = async (record) => {
    if (record && Object.keys(record).length > 0) {
      try {
        setFormulasLoading(true)
        if (record?.formula?.data && Object.keys(record?.formula?.data).length > 0) {
          const { request, formula } = record
          let jsonParse = {}
          if (request && Object.keys(request).length > 0) {
            setJson(Object.keys(record.request).length > 0 ? JSON.stringify(record.request, 0, 2) : '')
            setJsonParse(request)
            jsonParse = await getJsonMapper(request)
            setJsonMapper(jsonParse)
          }
          setFormulaData(formula.data)
          updateCheckBox(jsonParse, formula.data, checkedBox, setCheckedBox)
          await waitVariablesFormat(checkedBox, variablesFormat)
          setFormulaStructure(record?.formula?.structure)
        }
        setFormulasLoading(false)
        setCanChangeJson(true)
      } catch (error) {
        setFormulasLoading(false)
      }
    }
  }

  const getParentRule = async (parentRuleId) => {
    try {
      setLoadingParentFormula(true)
      let parentFormula = await businessRuleServices.solvedFormulaTest(null, parentRuleId)
      if (parentFormula) {
        setParentStructureFormula(parentFormula?.combine_formula)
        setParentInfo(parentFormula?.parent_rule_info)
      }
      setLoadingParentFormula(false)
    } catch (error) {
      setLoadingParentFormula(false)
    }
  }

  const getProductType = async () => {
    try {
      setLoadingProductType(true)
      const product_type = await productTypeServices.getByParam({ limit: 999 })
      if (product_type) {
        const remove_product_type_other = product_type.filter(
          (elem) => elem.ref_table_detail !== 'other_detail'
        )
        remove_product_type_other.push({
          ref_table_detail: 'other_detail',
          short_name: 'Otros',
          long_name: 'Otros',
          id: PRODUCT_TYPE_OTHER_ID,
        })
        setProductTypes(remove_product_type_other)
      } else {
        setProductTypes([])
      }
    } catch (error) {
      setProductTypes([])
    } finally {
      setLoadingProductType(false)
    }
  }

  const getRuleTypes = async () => {
    try {
      setLoadingRuleTypes(true)
      const allRuleTypes = await businessRuleServices.getRuleTypes()
      setRuleTypes(allRuleTypes)
      setLoadingRuleTypes(false)
    } catch (error) {
      setRuleTypes([])
      setLoadingRuleTypes(false)
    }
  }

  const getBusinessRules = async (name, initial_load = null) => {
    if (name || initial_load) {
      try {
        const param = name ? `name__ilike=${name}` : initial_load ? initial_load : ''
        setTimeout(async () => {
          setLoadingBusinessRules(true)
          const allBusinessRules = await businessRuleServices.getByAll(param)
          setBusinessRules(allBusinessRules)
          setLoadingBusinessRules(false)
        }, 1000)
      } catch (error) {
        setBusinessRules([])
        setLoadingBusinessRules(false)
      }
    }
  }

  const getWorkUnits = async () => {
    try {
      setLoadingWorkUnits(true)
      const work_unit = await workUnitServices.getByOrderParent()
      setAllWorkUnits(work_unit)
      setLoadingWorkUnits(false)
    } catch (error) {
      setAllWorkUnits([])
      setLoadingWorkUnits(false)
    }
  }

  const getDestinationTypes = async () => {
    try {
      setLoadingDestinationTypes(true)
      const allDestinationTypes = await businessRuleServices.getDestinationTypes()
      setDestinationTypes(allDestinationTypes)
      setLoadingDestinationTypes(false)
    } catch (error) {
      setDestinationTypes([])
      setLoadingDestinationTypes(false)
    }
  }

  const onChangeWorkUnit = async (work_units) => {
    try {
      if (work_units) {
        setProducts([])
        setCurrentWorkUnit(work_units)
        const list_ids_work_units = work_units.reduce((accumulator, wu) => {
          const list_ids_work_unit = getAllChildrensId(wu)
          return [...accumulator, ...list_ids_work_unit]
        }, [])
        // getBusinessRecord(list_ids_work_units)
        setWorkUnitIdS(list_ids_work_units)

        if (selectedRuleType === PAYMENT_METHOD) {
          setLoadingPaymentTypes(true)
          const paymentTypesPromises = work_units.map((wu) => {
            let token = wu?.token ? wu.token : wu?.value
            return getPaymentTypesService(token)
          })

          const paymentTypesResults = await Promise.all(paymentTypesPromises)
          const combinedPaymentTypes = paymentTypesResults.flat()
          const uniquePaymentTypes = combinedPaymentTypes.reduce((accumulator, current) => {
            if (!accumulator.some((item) => item.short_name === current.short_name)) {
              accumulator.push(current)
            }
            return accumulator
          }, [])
          setPaymentTypes(uniquePaymentTypes)
          setLoadingPaymentTypes(false)
        }
      }
    } catch (error) {
      setLoadingPaymentTypes(false)
    }
  }

  const getProducts = async (workUnitIds, businessUnits, defaultBusinessUnit, initial) => {
    try {
      setLoadingProducts(true)
      let allProducts = []
      const queryParamsString = workUnitIds.map((id) => `id=${id}`).join('&')
      const products_by_work_units = await productServices.getProductByWorkUnitIds(queryParamsString)
      const getWorkUnitById = (currentWorkUnit, work_unit_id) => {
        try {
          const work_unit_found = currentWorkUnit.find((workUnit) => workUnit?.id == work_unit_id)
          return work_unit_found?.short_name
        } catch (error) {
          return null
        }
      }

      const addWorkUnitNameInProducts = async (allProducts) => {
        // add work unit names in products which not found wu names
        try {
          const allProductsWithoutNames = allProducts
            .filter((product) => !product.work_unit_name)
            .map((product) => ({ work_unit_id: product?.work_unit_id, work_unit_name: null }))
          if (!allProductsWithoutNames) return allProducts

          const workUnitIds = [...new Set(allProductsWithoutNames.map((item) => item.work_unit_id))]
          const queryParamsString = workUnitIds.map((id) => `id=${id}`).join('&')
          const work_unit_found = await workUnitServices.getByParam(
            {
              operator: 'equal',
            },
            queryParamsString
          )
          const workUnitMap = new Map()
          work_unit_found.forEach((unit) => {
            workUnitMap.set(unit.id, unit.short_name)
          })
          const updatedProducts = allProducts.map((product) => {
            if (!product.work_unit_name && workUnitMap.has(product.work_unit_id)) {
              product.work_unit_name = workUnitMap.get(product.work_unit_id)
            }
            return product
          })

          return updatedProducts
        } catch (error) {
          return allProducts
        }
      }

      if (products_by_work_units) {
        allProducts = products_by_work_units
          .filter((elem) => filterProducts(elem, productType))
          .map((elem) => ({
            token: elem.token_id,
            name: elem.product_relation.long_name,
            ref_table: getRefTableDetail(elem.product_relation.ref_table_detail),
            product_type_id: elem.product_relation.product_type_id,
            hash_product: elem.product_relation.hash_product,
            work_unit_id: elem?.work_unit_id,
            work_unit_name: getWorkUnitById(currentWorkUnit, elem?.work_unit_id),
          }))
      }

      allProducts = await addWorkUnitNameInProducts(allProducts)

      if (selectedRuleType === PAYMENT_CHARGE) {
        allProducts = [{ token: 'generalToken', name: 'Todos', ref_table: 'general' }]
      }

      setProducts(allProducts)
      const product = allProducts.find((elem) =>
        elem.ref_table === selectedProduct?.[0]?.ref_table || initial
          ? elem.token === record?.product_token
          : undefined
      )
      setSelectedProduct(product || null)
      // if (!initial && product) {
      //   getStaticJson(currentWorkUnit.token, product.token)
      // }
      setLoadingProducts(false)

      // if (defaultBusinessUnit) {
      //   onChangeBusinessUnit(allProducts, businessUnits, defaultBusinessUnit)
      // }
    } catch (error) {
      setProducts([])
      setLoadingProducts(false)
    }
  }

  const onChangeBusinessUnit = async (products, businessUnits, businessUnitTokens) => {
    if (businessUnitTokens && businessUnitTokens?.length) {
      const selectedBusinessUnitIds = businessUnits
        .filter((unit) => businessUnitTokens.includes(unit.token))
        .map((unit) => unit.id)
      setBusinessUnitIds(selectedBusinessUnitIds)
      setBusinessUnit(businessUnitTokens)

      if (selectedBusinessUnitIds && selectedBusinessUnitIds?.length) {
        const queryParamsString = selectedBusinessUnitIds.map((id) => `id=${id}`).join('&')
        const products_by_business_units = await businessUnitServices.getProductsByBusinessUnits(
          queryParamsString
        )
        const productsAux = products.filter((elem) => !elem.business_product)
        const products_format = products_by_business_units
          .filter(
            (elem) =>
              !productsAux.some((product) => product.token === elem.product_by_work_unit_relation.token_id) &&
              filterProducts(elem, productType)
          )
          .map((elem) => ({
            business_product: true,
            token: elem.product_by_work_unit_relation.token_id,
            name: elem.name,
            ref_table: elem.product_by_work_unit_relation.product_relation.ref_table_detail.split('_')[0],
            product_type_id: elem?.product_by_work_unit_relation?.product_relation?.product_type_id,
            hash_product: elem?.product_by_work_unit_relation?.product_relation?.hash_product,
          }))
        setProducts([...productsAux, ...products_format])
      }
    } else {
      const productsAux = products.filter((elem) => !elem.business_product)
      setProducts(productsAux)
    }
  }

  const onChangeProduct = (e) => {
    const tokens = e.target.value
    if (tokens) {
      const product = products.find((elem) => elem.token === tokens?.[0])
      if (product?.ref_table === AIR) {
        getAirData(product?.product_type_id)
      } else if (product?.ref_table === HOTEL) {
        getHotelData()
      }

      // if (product) {
      //   getStaticJson(null, product.token)
      // }
      const productsFound = tokens
        .map((token) => products.find((product) => product.token === token))
        .filter(Boolean)
      const hashProducts = productsFound.map(({ hash_product }) => hash_product)
      setSelectedProduct(productsFound)
      // Eliminando duplicados
      const uniqueHashProducts = [...new Set(hashProducts)]
      setHashProducts(uniqueHashProducts)
    }
  }

  const getStaticJson = async (workUnit = null, product = null, ruleType = null) => {
    setShowJsonInput(false)

    const workUnitAux = workUnit || currentWorkUnitToken
    const productAux = product || selectedProduct?.[0]?.token
    const ruleTypeAux = ruleType || selectedRuleType
    if (workUnitAux && productAux && ruleTypeAux) {
      try {
        const staticJson = await businessRuleServices.getStaticJson(workUnitAux, productAux, ruleTypeAux)
        setJson(JSON.stringify(staticJson.static_json, 0, 2))
      } catch (error) {
        setJson('')
      }
    }
  }

  const getAirData = (product_type_id) => {
    if (airAirlines.length === 0) {
      getAirlines()
    }
    if (airSuppliers.length === 0) {
      getAirSuppliers(product_type_id)
    }
  }

  const getAirlines = async () => {
    try {
      setLoadingAirAirlines(true)
      const allAirlines = await businessRuleServices.getAirlines()
      setAirAirlines(allAirlines)
      setLoadingAirAirlines(false)
    } catch (error) {
      setAirAirlines([])
      setLoadingAirAirlines(false)
    }
  }

  const getAirSuppliers = async (product_type_id) => {
    try {
      setLoadingAirSuppliers(true)
      const params = {
        operator: 'equal',
        product_type_id: product_type_id,
        limit: 999,
        is_active: true,
      }
      const allSuppliers = await supplierServices.getByParam(params)
      setAirSuppliers(allSuppliers)
      setLoadingAirSuppliers(false)
    } catch (error) {
      setAirSuppliers([])
      setLoadingAirSuppliers(false)
    }
  }

  const getHotelData = (defaultCountries = null) => {
    if (hotelCountries.length === 0) {
      getCountries(defaultCountries)
    }
  }

  const getCountries = async (defaultCountries = null) => {
    try {
      setLoadingHotelCountries(true)
      const allCountries = await businessRuleServices.getCountries()
      setHotelCountries(allCountries)
      setLoadingHotelCountries(false)

      if (defaultCountries) {
        getCities(defaultCountries)
      }
    } catch (error) {
      setHotelCountries([])
      setLoadingHotelCountries(false)
    }
  }

  const getCities = async (countries, currentCities = [], selectedCountries = []) => {
    if (Array.isArray(countries)) {
      const filteredCountries = countries.filter((elem) => !selectedCountries.includes(elem))

      if (filteredCountries.length > 0) {
        try {
          setLoadingHotelCities(true)
          const promises = filteredCountries.map(businessRuleServices.getCitiesByCountry)
          Promise.all(promises).then((allCities) => {
            setHotelCities([...currentCities, ...allCities.flat()])
          })
          setLoadingHotelCities(false)
        } catch (error) {
          setLoadingHotelCities(false)
        }
      } else {
        setHotelCities((current) => current.filter((elem) => countries.includes(elem.country_id)))
      }

      setSelectedCountries(countries)
      return
    }
    let {
      target: { value },
    } = countries
    const contryId = value.find((elem) => !selectedCountries.includes(elem))
    if (contryId) {
      try {
        setLoadingHotelCities(true)
        const allCities = await businessRuleServices.getCitiesByCountry(contryId)
        setHotelCities((current) => [...current, ...allCities])
        setLoadingHotelCities(false)
      } catch (error) {
        setLoadingHotelCities(false)
      }
    } else {
      setHotelCities((current) => current.filter((elem) => countries.includes(elem.country_id)))
    }

    setSelectedCountries(countries)
  }

  const onChangeRuleType = (e) => {
    const value = e.target.value
    setSelectedRuleType(value)
    // getStaticJson(null, null, value)

    if (value === PAYMENT_METHOD && currentWorkUnitToken) {
      getPaymentType(currentWorkUnitToken)
    }
  }

  const getPaymentType = async (work_units, defaultPayment) => {
    try {
      setLoadingPaymentTypes(true)
      const paymentTypesPromises = work_units.map((wu) => {
        let token = wu?.token ? wu.token : wu?.value
        return getPaymentTypesService(token)
      })

      const paymentTypesResults = await Promise.all(paymentTypesPromises)
      const combinedPaymentTypes = paymentTypesResults.flat()
      const uniquePaymentTypes = combinedPaymentTypes.reduce((accumulator, current) => {
        if (!accumulator.some((item) => item.short_name === current.short_name)) {
          accumulator.push(current)
        }
        return accumulator
      }, [])
      setPaymentTypes(uniquePaymentTypes)
      if (defaultPayment) {
        onChangePaymentType(uniquePaymentTypes, defaultPayment.id, defaultPayment.payment_method)
      }
    } catch (error) {
    } finally {
      setLoadingPaymentTypes(false)
    }
  }

  const getPaymentTypesService = async (workUnitToken) => {
    try {
      const allPaymentTypes = await businessRuleServices.getPaymentTypesByWorkUnitToken(workUnitToken)
      const paymentTypesAux = allPaymentTypes ? allPaymentTypes.map((elem) => elem.payment_type_relation) : []
      return paymentTypesAux
    } catch (error) {
      return []
    }
  }

  const onChangePaymentType = (paymentTypes, paymentTypeId, defaultPaymentMethod = null) => {
    const paymentType = paymentTypes.find((elem) => elem.id === paymentTypeId)
    if (paymentType && paymentType.config?.endpoint) {
      const parameter = paymentType.config.endpoint.parameter
      const url = paymentType.config.endpoint.url
      getPaymentMethodsBank(url.replace(`{${parameter}}`, currentWorkUnit[parameter]), defaultPaymentMethod)
    } else {
      setPaymentMethodsBank([])
    }
  }

  const getPaymentMethodsBank = async (url, defaultPaymentMethod) => {
    try {
      const allPaymentMethodsBank = await businessRuleServices.getPaymentMethods(url)
      setPaymentMethodsBank(allPaymentMethodsBank)

      if (defaultPaymentMethod) {
        const defaultPaymentMethodsCards = defaultPaymentMethod
          ?.map((paymentMethod) => paymentMethod.cards.map((card) => `${paymentMethod.id}_${card.id}`))
          .flat()
        setSelectedPaymentMethodsCard(defaultPaymentMethodsCards)
        onChangePaymentMethod(
          allPaymentMethodsBank,
          defaultPaymentMethod.map((elem) => elem.id)
        )
      }
    } catch (error) {
      setPaymentMethodsBank([])
    }
  }

  const onChangePaymentMethod = (paymentMethodsBank, paymentMethods) => {
    const cards = paymentMethods
      .map((idMethod) => {
        const paymentMethod = paymentMethodsBank.find((elem) => elem.id === idMethod)
        if (paymentMethod?.cards) {
          return paymentMethod.cards.map((card) => ({
            ...card,
            idMethod: paymentMethod.id,
            nameMethod: paymentMethod.long_name,
            customId: `${paymentMethod.id}_${card.id}`,
          }))
        }
        return []
      })
      .flat()

    setSelectedPaymentMethodsBank(paymentMethods)
    const cardsIds = cards.map((elem) => elem.customId)
    setSelectedPaymentMethodsCard((current) => current.filter((elem) => cardsIds.includes(elem)))
  }

  const checkFormulas = (array) => {
    if (array.length) {
      return array.every((item) => {
        if (item.isData) {
          return item.value !== ''
        } else {
          return item.children.length === 2 && checkFormulas(item.children)
        }
      })
    }

    return true
  }

  const getOptionLabelBusinessUnit = (businessUnit) => {
    let string = ''
    const business_name = businessUnit?.fiscal_data_relation?.name || businessUnit?.fiscal_data_name
    const fantasy_name = businessUnit?.fantasy_name

    if (business_name) {
      string += '(RS) ' + business_name
    }
    if (fantasy_name) {
      string += (business_name ? ' - (NF) ' : '') + fantasy_name
    }
    
    return string
  }

  const beforeSubmit = async (captureImage = false) => {
    // const { isParse } = checkJson()
    const checkFormulasAux = checkFormulas(formulas)

    if (!checkFormulasAux) {
      notify('ra.field.invalid_formulas', { type: 'error' })
      return null
    }
    // if (captureImage) {
    //   await waitForPicture()
    //   await CanvasImage(exportRef) ||| this will be uses ||||
    // }
    if (checkFormulasAux) {
      return true
    }
    return false
  }

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.business-rule') },
    })
    redirect('/business-rule')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.business-rule') },
    })
  }

  const setParentRule = (value) => {
    if (value) {
      const parentId = value?.id
      setCurrentParentRuleId(parentId)
    }
  }

  const onSubmit = async (formData) => {
    try {
      if (
        selectedRuleType !== PAYMENT_METHOD &&
        selectedRuleType !== CONTENT &&
        selectedRuleType !== SETTING
      ) {
        setStartTakePicture(true)
        const isSuccess = await beforeSubmit(true)
        if (!isSuccess) {
          return null
        }
      }
      const dataByTransform = {
        formulas,
        jsonParse,
        selectedProduct,
        selectedRuleType,
        paymentTypes,
        work_unit_token: currentWorkUnitToken, // get from data
        checkedBox,
        hash_products: hashProducts.length ? hashProducts : record?.hash_product,
      }
      await update(
        'business-rule',
        { id: formData.id, data: transform(formData, dataByTransform, transformData) },
        { mutationMode: 'pessimistic', onSuccess, onError }
      )
    } catch (error) {
      console.error('Error:', error)
      onError()
      return
    }
  }

  const showCurrentsWorkunit = (currentWorkUnit) => {
    if (Array.isArray(currentWorkUnit)) {
      return currentWorkUnit.map((work_unit) => work_unit?.long_name).join(', ')
    }
  }

  const getBusinessRecord = async () => {
    try {
      setLoadingBusinessUnits(true)
      const queryParamsStringToken =  record?.business_unit_token.map((token) => `token=${token}`).join('&')
   
      const businessUnit = await businessUnitServices.getByAll(
        { "operator" : "or_equal"},
        queryParamsStringToken
      )

      if (businessUnit) {
        setBusinessUnits(businessUnit.map((row) => ({ ...row, fiscal_data_name : row?.fiscal_data_relation?.name})))
        return
      }
      setBusinessUnits([])
    } catch (error) {
      setBusinessUnits([])
    } finally {
      setLoadingBusinessUnits(false)
    }
  }

  let searchTimeoutBusinessUnit
  const getBusinessUnit = async (user, length = 2) => {
    clearTimeout(searchTimeoutBusinessUnit)
   
    
    if (
      (!user?.fantasy_name || user.fantasy_name.length < length) &&
      (!user?.business_name || user.business_name.length < length)
    ) {
      setOptionBusinessUnit([])
      return
    }

    searchTimeoutBusinessUnit = setTimeout(async () => {
      try {
        setLoadingBusinessUnit(true)
        
        const queryParamsString = currentWorkUnit.map((wu) => `work_unit_id=${wu?.i}`).join('&')
        let filter = {
          fantasy_name__ilike: user?.fantasy_name,
        }
        if (user?.fantasy_name__ilike) {
          filter.fiscal_data__name__ilike = user?.fantasy_name__ilike
        }
        if (user?.business_name) {
          filter.fiscal_data__name__ilike = user?.business_name
        }
        const business_unit = await businessUnitServices.business_unit_filter(filter, queryParamsString)
        setBusinessUnitsOptionsSelected([...businessUnitsOptionsSelected,...optionBusinessUnit.filter(unit=>businessUnit.includes(unit.token))])
        setOptionBusinessUnit(business_unit)
      } catch (error) {
        setOptionBusinessUnit([])
      } finally {
        setLoadingBusinessUnit(false)
      }
    }, 1000)
  }
 
  const filteredOptions = useMemo(() => {
    const arrayToFilter = [...businessUnitsOptionsSelected,...optionBusinessUnit]
    return arrayToFilter.filter(
      (option) => !businessUnits.some((selected) => selected.token === option.token)
    )
  }, [businessUnits, optionBusinessUnit])

  useEffect(() => {
  // Cuando cambian las opciones (p. ej., después de buscar), scrollear abajo
    if (menuRef.current) {
      const list = menuRef.current.querySelector('ul');
      if (list) list.scrollTop = list.scrollHeight;
    }
  }, [filteredOptions]);

  return (
    <Edit {...props} actions={null}>
      <CardCommon title={translate('ra.title.edit_businessRule')}>
        <SimpleForm
          onSubmit={onSubmit}
          toolbar={<CardCrudBottomButtons btnSave={true} beforeSubmit={beforeSubmit} loading={loading} />}
        >
          <Box width='100%'>
            <RemoveProductIfProductChange currentWorkUnitToken={currentWorkUnitToken} />
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.name')} required md={6} lg={4}>
                <TextInput
                  source='name'
                  label=''
                  validate={[required(), (name) => validateNameIsValid(name, record.name)]}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.description')} required md={6} lg={4}>
                <TextInput source='description' label='' validate={[required()]} />
              </EditInputsWrap>
            </Grid>

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.rule_type')} required md={6} lg={4}>
                {loadingRuleTypes ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='rule_type_id'
                    options={TranslateRuleType(ruleTypes || [], translate)}
                    label=''
                    optionsText={['long_name']}
                    onChange={onChangeRuleType}
                    validate={[required()]}
                    defaultValue={record?.rule_type?.id}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.parent_businessRule')} md={6} lg={4}>
                <AutocompleteInput
                  source={'parent_rule'}
                  options={businessRules}
                  loading={loadingBusinessRules || false}
                  optionsText={['name']}
                  optionValue='id'
                  onSearch={getBusinessRules}
                  resetOnLoad={false}
                  onChange={(e) => setParentRule(e.target.value)}
                  defaultValue={
                    record?.parent_rule
                      ? businessRules.find((businessRule) => businessRule.id === record.parent_rule)
                      : null
                  }
                />
              </EditInputsWrap>
              {selectedRuleType === LIQUIDATION && (
                <EditInputsWrap label={translate('ra.field.rule_liquidation_type')} md={6} lg={4} required>
                  <SelectInput
                    source='rule_liquidation_type'
                    options={[
                      { short_name: 'RETAIL', long_name: 'Minorista' },
                      { short_name: 'WHOLESALER', long_name: 'Mayorista' },
                      { short_name: 'SUPPLIER', long_name: 'Proveedor' },
                    ]}
                    label=''
                    multiple
                    optionValue='short_name'
                    optionsText={['long_name']}
                    validate={[required()]}
                  />
                </EditInputsWrap>
              )}
            </Grid>

            <Grid container spacing={3}>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
              >
                <Box sx={style}>
                  <Typography
                    id='modal-modal-title'
                    variant='h5'
                    component='h2'
                    style={{ fontWeight: 'bold', fontSize: '1.5rem' }}
                  >
                    {translate('ra.title.select_work_unit')}
                  </Typography>
                  <Typography
                    variant='body2'
                    style={{ marginBottom: '20px', marginLeft: '10px', color: '#666', fontSize: '13px' }}
                  >
                    {translate('ra.message.instructive_work_unit_select')}
                  </Typography>
                  <TreeViewCheck
                    checked={currentWorkUnitToken}
                    setChecked={setCurrentWorkUnitToken}
                    nodes={allWorkUnits}
                    setExpanded={setExpanded}
                    expanded={expanded}
                  />
                </Box>
              </Modal>
              <EditInputsWrap label={translate('ra.field.work_unit')} required md={6} lg={4}>
                {loadingWorkUnits ? (
                  <Skeleton variant='rectangular' width={'100%'} height={50} />
                ) : (
                  <Button
                    sx={{
                      width: '100%',
                      height: 'auto',
                      minHeight: '40px',
                    }}
                    onClick={handleOpen}
                    variant='outlined'
                  >
                    {currentWorkUnitName?.length ? currentWorkUnitName : translate('ra.action.select')}
                  </Button>
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.business_unit')} md={8} lg={8} required>
                <SelectInputSearch
                  size='small'
                  MenuProps={{
                    PaperProps: {
                      ref: menuRef,
                    },
                  }}
                  source='business_unit_token'
                  options={[
                    {
                      token: 'all',
                      fantasy_name: 'Todas',
                      fiscal_data_name: 'Todas',
                      id: 9999999,
                    },
                    ...businessUnits,
                    ...filteredOptions,
                  ]}
                  label=''
                  getOptionLabel={getOptionLabelBusinessUnit}
                  fields={['fantasy_name', 'business_name']}
                  optionsText={['long_name']}
                  loading={loadingBusinessUnits || loadingBusinessUnit}
                  separator=' - '
                  optionValue='token'
                  onOptionsClose={(selectedValues) => {
                    onChangeBusinessUnit(products, businessUnits, selectedValues)
                  }}
                  validate={[required()]}
                  onSearch={getBusinessUnit}
                  defaultValue={selectedBusinessUnit}
                  multiple
                />
              </EditInputsWrap>

              {selectedRuleType !== PAYMENT_CHARGE && (
                <EditInputsWrap label={translate('ra.field.product_type')} required md={4} lg={2}>
                  {loadingProductType ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      source='product_type'
                      options={productTypes || []}
                      label=''
                      optionsText={['long_name']}
                      optionValue='id'
                      onChange={(e) => setProductType(e?.target?.value)}
                      showSearch
                      validate={[required()]}
                      defaultValue={productType ? productType : null}
                    />
                  )}
                </EditInputsWrap>
              )}
              <EditInputsWrap label={translate('ra.field.product')} md={6} lg={4} required>
                {loadingProducts ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='product_id'
                    options={products}
                    label=''
                    optionsText={['name', 'work_unit_name']}
                    optionValue='token'
                    multiple
                    showSearch
                    onChange={onChangeProduct}
                    validate={[required()]}
                    defaultValue={selectedProduct?.map((product) => product?.token)}
                  />
                )}
              </EditInputsWrap>
            </Grid>

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.start_validity_rule')}>
                <DatePickers source='rule_date_start' viewsShow={false} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.end_validity_rule')}>
                <FormDataConsumer>
                  {({ formData }) => (
                    <DatePickers
                      minDate={formData.rule_date_start ? dayjs(formData.rule_date_start) : false}
                      disabled={!formData.rule_date_start}
                      source='rule_date_end'
                      viewsShow={false}
                      required={formData.rule_date_start ? true : false}
                    />
                  )}
                </FormDataConsumer>
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.is_active')} required>
                <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
              </EditInputsWrap>
            </Grid>

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.start_reservation_date')}>
                <DatePickers source='reservation_date_from' viewsShow={false} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.end_reservation_date')}>
                <FormDataConsumer>
                  {({ formData }) => (
                    <DatePickers
                      minDate={
                        formData?.reservation_date_from ? dayjs(formData?.reservation_date_from) : false
                      }
                      disabled={!formData?.reservation_date_from}
                      source='reservation_date_to'
                      viewsShow={false}
                      required={formData.reservation_date_from ? true : false}
                    />
                  )}
                </FormDataConsumer>
              </EditInputsWrap>
            </Grid>
            {selectedRuleType !== SETTING && selectedRuleType !== CONTENT && (
              <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.start_service_date')}>
                  <DatePickers source='date_in_from' viewsShow={false} />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.end_service_date')}>
                  <FormDataConsumer>
                    {({ formData }) => (
                      <DatePickers
                        minDate={formData?.date_in_from ? dayjs(formData?.date_in_from) : false}
                        disabled={!formData?.date_in_from}
                        source='date_in_to'
                        viewsShow={false}
                        required={formData.date_in_from ? true : false}
                      />
                    )}
                  </FormDataConsumer>
                </EditInputsWrap>
              </Grid>
            )}

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.priority')} required>
                <NumberInput
                  source='priority'
                  label=''
                  fullWidth
                  validate={[
                    required(),
                    minValue(1),
                    maxValue(100000),
                    // (priority) =>
                    //   validatePriority(priority, currentWorkUnitToken, selectedProduct, record.priority),
                  ]}
                  noDecimal
                  helperText={translate('ra.message.number_input')}
                  min={1}
                />
              </EditInputsWrap>
            </Grid>

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.destination_type')} required>
                {loadingDestinationTypes ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='destination_type_id'
                    options={destinationTypes}
                    label=''
                    optionsText={['name']}
                    validate={[required()]}
                    defaultValue={record?.destination_type_id}
                  />
                )}
              </EditInputsWrap>
              {/* {selectedRuleType === BILLING && (
                <EditInputsWrap label={translate('ra.field.config')}>
                  <TextInputRA
                    source='json_billing'
                    label=''
                    fullWidth
                    multiline
                    validate={isJsonValidate}
                    format={(v) => {
                      return JSON.stringify(v ? v : undefined)
                    }}
                    parse={(v) => {
                      try {
                        if (v.length >= 2) {
                          return JSON.parse(v)
                        }
                      } catch (e) {
                        notify('ra.field.invalid_json', { type: 'error' })
                        return undefined
                      }
                    }}
                  />
                </EditInputsWrap>
              )} */}
            </Grid>

            {(selectedRuleType === BILLING || selectedRuleType === LIQUIDATION) && (
              <Grid container spacing={1} style={{ marginTop: '25px' }}>
                <EditInputsWrap label={translate('ra.field.is_berlin')}>
                  <BooleanInput source='is_berlin' label={null} />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.base_to_billing')} required md={6} lg={4}>
                  {loadingBaseBilling ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      source='base_to_billing'
                      options={baseToBilling || []}
                      label=''
                      optionsText={['name']}
                      optionValue='value'
                      multiple
                      showSearch
                      defaultValue={selectedBillingBases}
                      validate={[required()]}
                    />
                  )}
                </EditInputsWrap>
              </Grid>
            )}

            {selectedProduct?.[0]?.ref_table === AIR && (
              <GetAirFields
                record={record}
                defaultValue
                setLoadingAirSources={setLoadingAirSources}
                loadingAirAirlines={loadingAirAirlines}
                airAirlines={airAirlines}
                loadingAirSuppliers={loadingAirSuppliers}
                airSuppliers={airSuppliers}
                selectedRuleType={selectedRuleType}
              />
            )}

            {selectedProduct?.[0]?.ref_table === HOTEL && (
              <GetHotelFields
                loadingHotelCountries={loadingHotelCountries}
                hotelCountries={hotelCountries}
                getCities={getCities}
                loadingHotelCities={loadingHotelCities}
                hotelCities={hotelCities}
                selectedCountries={selectedCountries}
                record={record}
              />
            )}

            {selectedProduct?.[0]?.ref_table === CAR && <GetCarFields record={record} />}

            {(selectedProduct?.[0]?.ref_table === TRAIN_SEGMENT ||
              selectedProduct?.[0]?.ref_table === TRAIN_PASSES) &&
              selectedRuleType !== SETTING &&
              selectedRuleType !== CONTENT && (
                <GetTrainSegmentFields record={record} selectedRuleType={selectedRuleType} />
              )}

            {selectedProduct?.[0]?.ref_table === OTHER &&
              (selectedRuleType === LIQUIDATION ||
                selectedRuleType === BILLING ||
                selectedRuleType === PRICE) && (
                <GetOtherProductFields product={selectedProduct?.[0]} record={record} />
              )}

            {selectedRuleType === PAYMENT_METHOD && (
              <GetPaymentFields
                currentWorkUnit={currentWorkUnit}
                paymentTypes={paymentTypes}
                onChangePaymentType={onChangePaymentType}
                paymentMethodsBank={paymentMethodsBank}
                loadingPaymentTypes={loadingPaymentTypes}
                record={record}
                selectedPaymentMethodsBank={selectedPaymentMethodsBank}
                selectedPaymentMethodsCard={selectedPaymentMethodsCard}
                onChangePaymentMethod={onChangePaymentMethod}
              />
            )}
            {selectedRuleType === INSTALLMENT_METHOD && <GetInstallmentFields record={record} />}

            {selectedRuleType === PAYMENT_CHARGE && currentWorkUnit?.length && (
              <GetPaymentChargeComponentFields
                workUnitToken={currentWorkUnit}
                record={record && record?.payment_charge}
              />
            )}

            {selectedRuleType === CONTENT && <ContentRuleComponent record={record} />}
            {selectedRuleType === SETTING && <SettingRuleComponent record={record} />}
          </Box>
          {selectedRuleType !== PAYMENT_METHOD &&
            selectedRuleType !== CONTENT &&
            selectedRuleType !== SETTING && (
              <CheckboxContext.Provider
                value={{ checkedBox, setCheckedBox, variablesFormat, setVariablesFormat }}
              >
                <Box style={{ width: '100%', height: 'auto', position: 'relative' }}>
                  <Paper style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <EditInputsWrap label={translate('ra.field.json')}>
                      <AdapterToMapperJson
                        json={json}
                        setIsAddVar={setIsAddVar}
                        showJsonInput={showJsonInput}
                        jsonMapper={jsonMapper}
                        loading={loadingJsonMapper}
                        getStaticJson={getStaticJson}
                        setJson={setJson}
                        setShowJsonInput={setShowJsonInput}
                      />
                    </EditInputsWrap>
                    {currentParentRuleId > 0 && (
                      <CardParentFormula
                        loading={loadingParentFormula}
                        initialFormulas={parentStructureFormula}
                        parentInfo={parentInfo}
                      />
                    )}

                    {openTestFormula && (
                      <CardTestFormula
                        child_formula={formulas}
                        child_checkedBox={checkedBox}
                        currentParentRuleId={currentParentRuleId}
                        openTestFormula={openTestFormula}
                        handleCloseTestFormula={handleCloseTestFormula}
                        jsonRequestExample={selectedRuleType === PRICE && jsonParse}
                      />
                    )}

                    <Box style={{ display: 'flex' }}>
                      <Box style={{ display: 'flex', flex: 1, marginLeft: '20px' }}>
                        <Grid container spacing={3}>
                          <GlobalVariables record={record} />
                        </Grid>
                      </Box>
                      <Box style={{ display: 'flex', flex: 1, margin: '10px 0px', justifyContent: 'right' }}>
                        <Button
                          sx={{
                            width: 'auto',
                            height: '40px',
                            margin: '0px 20px 0px 10px',
                          }}
                          onClick={() => handleOpenTestFormula()}
                          variant='outlined'
                          disabled={formulas?.structure?.length || formulas.length === 0 ? true : false}
                        >
                          {translate('ra.action.test_rule')}
                        </Button>
                      </Box>
                    </Box>

                    <Box style={{ display: 'flex', width: '100%', margin: '10px 0px' }}>
                      <FormulaComponent
                        formulas={formulas}
                        setFormulas={setFormulas}
                        initialFormulas={formulaStructure}
                        loading={formulasLoading}
                      />
                    </Box>
                  </Paper>

                  {/* <Box
                    ref={exportRef}
                    style={{
                      position: 'absolute',
                      right: -22110,
                      width: '95%',
                      height: 'auto',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {startTakePicture && (
                      <CardTestFormula
                        child_formula={formulas}
                        child_checkedBox={checkedBox}
                        currentParentRuleId={currentParentRuleId}
                        openTestFormula={openTestFormula}
                        handleCloseTestFormula={handleCloseTestFormula}
                        jsonRequestExample={selectedRuleType === PRICE && jsonParse}
                      />
                    )}
                  </Box> */}
                </Box>

                {selectedRuleType === BILLING && (
                  <Grid container spacing={1} style={{ marginTop: '25px' }}>
                    <EditInputsWrap label={translate('ra.field.config')}>
                      <JsonInput source='json_billing' />
                    </EditInputsWrap>
                  </Grid>
                )}
              </CheckboxContext.Provider>
            )}
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
